
import { mapState } from 'vuex';

export default {
  props: {
    elevated: {
      type: Boolean,
      required: false,
      default: false
    } // elevated
  }, // props

  computed: {
    ...mapState('queue', {
      data: 'TrafficInLine'
    })
  } // computed
}; // export default
